﻿﻿export interface IAutomatedJob {
    taskId: string;
    lastRunWasSuccessful: boolean;
    lastRunDateTime: string;
    nextRunDateTime: string;
}
